import { render } from "./guide1.vue?vue&type=template&id=44203f81&ts=true"
import script from "./guide1.vue?vue&type=script&lang=ts"
export * from "./guide1.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__